import { Component, EventEmitter, Input, Output } from '@angular/core'
import { GenericLayer } from '../../../shared/model/layers/generic-layer'

@Component({
    selector: 'app-single-layer-detail',
    templateUrl: './single-layer-detail.component.html',
    styleUrls: ['./single-layer-detail.component.scss'],
})
export class SingleLayerDetailComponent {
    @Input()
    layer: GenericLayer | undefined | null

    @Input()
    colorPalette: string[]

    @Output()
    close = new EventEmitter<void>()

    get hasSliderControls(): boolean {
        return (
            !!this.layer?.opacityPercent ||
            !!this.layer?.opacityUnselectedPercent ||
            !!this.layer?.saturationPercent ||
            !!this.layer?.brightness ||
            !!this.layer?.contrast
        )
    }

    protected setSegmentationColorMode(segmentationColorMode: SegmentationColorMode): void {
        if (!this.layer || !this.layer.segmentationColor) {
            return
        }
        if (segmentationColorMode == SegmentationColorMode.RandomSeed) {
            this.layer.segmentationColor?.setValue(null)
        } else {
            this.layer.segmentationColor?.setValue('#ff0000')
        }
    }

    segmentationColorMode(segmentationColor: string | null): SegmentationColorMode {
        if (segmentationColor) {
            return SegmentationColorMode.FixedColor
        } else {
            return SegmentationColorMode.RandomSeed
        }
    }

    protected readonly SegmentationColorModeEnum = SegmentationColorMode
}

export enum SegmentationColorMode {
    RandomSeed = 'random',
    FixedColor = 'fixed',
}
